import React, { FunctionComponent, memo } from 'react';
import { Preset, Color, ShadeColor, FunctionColor } from '@lux/text';
import { Translate } from '@pegasus/translation';

import { Campaign } from '@shared/types/mylounge';

import { useConfig } from '@browsing/config';
import * as S from './discount.styles';

interface Props {
    campaign: Campaign;
    isPlusVariant?: boolean;
}

export const Discount: FunctionComponent<Props> = ({ campaign, isPlusVariant = false }) => {
    const config = useConfig();
    const isRRPComplainceEnabled = config.isEnabled('omnibusRRP');

    if (campaign.discount.isSpecial) {
        return (
            <S.Container>
                <S.SpecialText bold preset={Preset.M} $isPlusVariant={isPlusVariant}>
                    <Translate message="campaigns.campaignSpecial" />
                </S.SpecialText>
            </S.Container>
        );
    }

    if (isRRPComplainceEnabled) {
        return (
            <S.RRPRegularText
                preset={Preset.XS}
                color={ShadeColor.dark60}
                $isPlusVariant={isPlusVariant}
            >
                <Translate
                    message="campaigns.omniBusComplaince"
                    params={{ discount: `${campaign.discount.maxDiscount}` }}
                    html
                />
            </S.RRPRegularText>
        );
    }

    return (
        <S.Container>
            <S.RegularContainer>
                <S.RegularText
                    preset={Preset.XS}
                    color={ShadeColor.dark60}
                    $isPlusVariant={isPlusVariant}
                >
                    <Translate message="campaigns.upTo" />
                </S.RegularText>
                <S.MaxDiscountText
                    preset={Preset.M}
                    bold
                    color={Color.dark}
                    $isPlusVariant={isPlusVariant}
                >
                    {campaign.discount.maxDiscount}%
                </S.MaxDiscountText>
            </S.RegularContainer>
        </S.Container>
    );
};

export default memo(Discount);
